import React from 'react'
import { connect } from 'react-redux'
import classnames from 'classnames'
import { formatFunctions } from '@/helpers/functions'
import { getSafe } from '@/helpers/global';
import { PARAMS as requestParams } from '@/constants/params';
import { ACCOUNT_TYPE } from '@/constants/auth';
import { Converter } from '@/helpers/functions';
import { SERVICES_RESP } from '@/configurations';
import TabHeader from '@/components/TabHeader/TabHeader';
import '@/assets/styles/components/my-account/account-balance-one-row.scss';
import { CUSTOM_STYLES } from '@/constants/app';
import { dataType as types } from '@/constants/data-type';
import { accountActions } from '../../../actions/trading/account.actions';
import LoadingLayer from '../../../components/Spinner/LoadingLayer';

class AccountBalanceOneRow extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      accountBalance: [{ id: 1, title: 'account_balance_title', isActive: false }],
      ledgerBalance: '',
      portfolio: {},
      leftAsset: [
        { label: 'current_account_pending_settlement', value: '-' },
        { label: 'current_account_today_confirm_buy', value: '-' },
        { label: 'current_account_today_confirm_sell', value: '-' },

      ],
      rightAsset: [
        { label: 'current_account_outstanding_buy_order', value: '-' },
        { label: 'current_account_market_Value_of_physical_stock_sales', value: '-' },
        { label: 'current_account_total_purchasing_power', value: '-' },
      ],
      isLoading: false,
      market: 'HKEX',
      afterData: []
    }
  }

  render() {
    const { language, currentTradingAccount } = this.props
    const { ledgerBalance, portfolio, leftAsset, rightAsset, isLoading, accountBalance, afterData } = this.state
    return (
      <div className={classnames("account-balance-one-row-container", "overflow")}>
        <TabHeader accountData={afterData} onChangeAccount={this.setAccount} accountDropDown tabs={accountBalance} marketFilter refresh customStyle={CUSTOM_STYLES.HEADER_NORMAL} onChangeMarket={this.handleChangeMarket} onRefresh={this.getAccountBankBalance} />
        <LoadingLayer load={isLoading} />
        <div className="cash-account-profile-box">
          <div className="available-balance-box">
            <div>
              <div>{getSafe(() => language.current_account_available_balance_for_trading)}</div>
              <div className="large-size">{formatFunctions.dataFormat(ledgerBalance, types.CASH)}</div>
            </div>
          </div>
          <div className="cash-account-item">
            {
              leftAsset && leftAsset.map(item =>
                <div className="cash-account-data" key={item.label}>
                  <div>{getSafe(() => language[item.label])}</div>
                  <div style={{ color: item.textColor ? item.textColor : '' }}>
                    {item.value}
                  </div>
                </div>
              )
            }
          </div>
          <div className="cash-account-item">
            {
              rightAsset && rightAsset.map(item =>
                <div className="cash-account-data" key={item.label}>
                  <div>{getSafe(() => language[item.label])}</div>
                  <div>
                    {item.value}
                  </div>
                </div>
              )
            }
          </div>
          <div className="note-box">
            <ul>
              <li>
                <div className="header-text">{getSafe(() => language.current_account_important_notes)}</div>
                <div className="content-text">
                  {getSafe(() => language.current_account_note1)}
                </div>
              </li>
              <li>
                <div className="header-text">
                  {getSafe(() => language.current_account_available_balance_for_trading)}:
                </div>
                <div className="content-text">
                  {getSafe(() => language.current_account_note2)}
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    )
  }

  handleChangeMarket = (market) => {
    if (market) {
      this.setState({
        market: market.value
      }, () => {
        this.getAccountBankBalance()
      })

    }
  }

  setAccount = (list) => {
    this.setState({
      leftAsset: Converter.mapAccountAsset(list).SCBLeftAsset,
      rightAsset: Converter.mapAccountAsset(list).SCBRightAsset,
      ledgerBalance: list.ledgerBalance ? list.ledgerBalance : '-',
    })
  }

  getAccountBankBalance = () => {
    const { user, currentTradingAccount, language } = this.props;
    const { clientID } = currentTradingAccount
    if (clientID && user.token) {
      let params = {
        [requestParams.CLIENT_ID]: clientID,
        [requestParams.TRADING_ACCOUNT_ID]: clientID,
        [requestParams.LANGUAGE]: language.lang,
        [requestParams.MARKET_ID]: this.state.market

      }
      this.setState({
        isLoading: true
      })
      this.props.getAccountBankBalance(params, res => {
        this.setState({
          isLoading: false
        })
        if (res.result.errorCode === SERVICES_RESP.SUCCESS_CODE) {
          if (res.result.bankBalanceList.length !== 0) {
            let list = res.result.bankBalanceList[0]
            let afterData = res.result.bankBalanceList.map(item => {
              item.value = item.settlementAccount
              item.label = `${item.settlementAccount} ${item.currencyID}`
              return item
            })
            this.setState({
              leftAsset: Converter.mapAccountAsset(list).SCBLeftAsset,
              rightAsset: Converter.mapAccountAsset(list).SCBRightAsset,
              ledgerBalance: list.ledgerBalance ? list.ledgerBalance : '-',
              afterData
            })
          } else {
            this.doesGetData()
          }
        } else {
          this.doesGetData()
        }
      })
    }
  }

  doesGetData() {
    this.setState({
      leftAsset: [
        { label: 'current_account_pending_settlement', value: '-' },
        { label: 'current_account_today_confirm_buy', value: '-' },
        { label: 'current_account_today_confirm_sell', value: '-' },

      ],
      rightAsset: [
        { label: 'current_account_outstanding_buy_order', value: '-' },
        { label: 'current_account_market_Value_of_physical_stock_sales', value: '-' },
        { label: 'current_account_total_purchasing_power', value: '-' },
      ],
      ledgerBalance: '-',
      afterData: []
    })
  }

  accountType = (val) => {
    switch (val) {
      case ACCOUNT_TYPE.CASH: {
        return this.props.language.common_cash_account
      }
      case ACCOUNT_TYPE.MARGIN: {
        return this.props.language.common_margin_account
      }
    }
  }

  bindingColor(value) {
    if (value > 0) {
      return 'rise-color'
    } else if (value < 0) {
      return 'fall-color'
    } else {
      return ''
    }
  }

  componentDidMount() {
    this.getAccountBankBalance()
  }

  componentDidUpdate(preProps) {
    const { currentTradingAccount } = this.props
    if (currentTradingAccount && preProps.currentTradingAccount !== currentTradingAccount) {
      this.getAccountBankBalance()
    }
    if (this.props.token && this.props.token !== prevProps.token) {
      this.getAccountBankBalance()
    }
  }

  componentWillUnmount() {
    this.setState = () => {
      return
    }
  }

}

export default connect(
  state => ({
    language: state.app.language,
    user: state.auth.user,
    tradingAccount: state.auth.tradingAccount,
    currentTradingAccount: state.trade.currentTradingAccount,
    currentMarket: state.trade.currentMarket,
  }),
  dispatch => ({
    getAccountBankBalance: (p, res) => dispatch(accountActions.getAccountBankBalanceAction(p, res))
  })
)(AccountBalanceOneRow)